// src/App.jsx
import React, { useState, useEffect } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import useAuthStore from './stores/authStore';  // ← 追加

import Protect from './Protect';

import OtpVerify from './auth/OtpVerify';
import Login from './auth/Login';
import Signup from './auth/Signup';
import PasswordResetRequest from './auth/PasswordResetRequest';
import ResetPasswordForm from './auth/ResetPasswordForm';
import LoginSuccess from './auth/LoginSuccess';
import LoginView from './auth/LoginView';
import UserInvite from './auth/userinvite';

import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Notification from './components/notification';

import SstemSettings from './system/settings';

import AdminEventmanagement from './admin/eventmanagement';
import AdminUsermanagement from './admin/usermanagement';
import AdminDogmanagement from './admin/dogmanagement';
import AdminSystemsetting from './admin/systemsetting';

import OperatorOperatorevent from './operator/operatorevent';

import EnduserUsersettings from './enduser/usersettings';
import EnduserEntrydogs from './enduser/entrydogs';
import EnduserEventlist from './enduser/eventlist';
import EnduserEntryhistory from './enduser/entryhistory';

import './App.css';


const App = () => {
  // ← 削除: useState(WuserName, WuserType)
  // ← 削除: useNavigate() - handleLogout で使っていたが Header に移動
  
  const { userType, isAdmin, isOperator, isEnduser, isSystem } = useAuthStore();  // ← 追加

  const location = useLocation();
  const isPopup = new URLSearchParams(location.search).get('popup') === 'true';
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const ALL_ROLES = ['enduser', 'operator', 'admin', 'system'];

  useEffect(() => {
    const ua = navigator.userAgent;
    const isChrome = /Chrome/i.test(ua) && !/Edg|OPR/i.test(ua);
    if (isChrome) {
      document.documentElement.style.touchAction = 'manipulation';
      document.documentElement.style.webkitTapHighlightColor = 'transparent';
      document.body.style.touchAction = 'manipulation';
      document.body.style.webkitTapHighlightColor = 'transparent';
    }
  }, []);

  // ← 削除: handleLogout (Header に移動済み)

  const Layout = ({ children }) => (
    <div>
      <Header
        onToggleSidebar={() => setSidebarOpen(v => !v)}
        // ← 削除: WuserName, onLogout, userType (authStore から取得)
      />
      <div className={`main-content has-sidebar`}>
        <Sidebar
          userType={userType}
          isOpen={isSidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />
        <div className="content">{children}</div>
      </div>
    </div>
  );

  return (
    <div className="app-container">
      <Routes>
        {/* 認証前 */}
        <Route path="/login" element={<Login />} />  {/* ← props 削除 */}
        <Route path="/otpverify" element={<OtpVerify />} />  {/* ← props 削除 */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/password-reset-request" element={<PasswordResetRequest />} />
        <Route path="/reset-password" element={<ResetPasswordForm />} />
        <Route path="/login-success" element={<LoginSuccess />} />  {/* ← props 削除 */}
        <Route path="/auth/notice/:kind" element={<LoginView />} />
        <Route path="/userinvite/*" element={<UserInvite />} />

        
        {/* ============== Admin（admin/system） ============== */}
        <Route
          path="/admin/*"
          element={
            <Protect allowTypes={['admin', 'system']}>
              <Layout>
                <Routes>
                  <Route path="eventmanagement" element={<AdminEventmanagement />} />
                  <Route path="usermanagement" element={<AdminUsermanagement />} />
                  <Route path="dogmanagement" element={<AdminDogmanagement />} />
                  <Route path="systemsetting" element={<AdminSystemsetting />} />
                                   
                  <Route path="*" element={<Navigate to="dashboard" replace />} />
                </Routes>
              </Layout>
            </Protect>
          }
        />

        {/* ============== Operator ============== */}
        <Route
          path="/operator/*"
          element={
            <Protect allowTypes={['operator', 'admin', 'system']}>
              <Layout>
                <Routes>
                  <Route path="operatorevent" element={<OperatorOperatorevent />} />
                  <Route path="*" element={<Navigate to="operatorevent" replace />} />
                </Routes>
              </Layout>
            </Protect>
          }
        />

        {/* ============== Enduser ============== */}
        <Route
          path="/enduser/*"
          element={
            <Protect allowTypes={['enduser', 'operator', 'admin', 'system']}>
              <Layout>
                <Routes>
                  <Route path="usersettings" element={<EnduserUsersettings />} />
                  <Route path="entrydogs" element={<EnduserEntrydogs />} />
                  <Route path="eventlist" element={<EnduserEventlist />} />
                  <Route path="entryhistory" element={<EnduserEntryhistory />} />
                  <Route path="*" element={<Navigate to="usersettings" replace />} />
                </Routes>
              </Layout>
            </Protect>
          }
        />

        {/* ============== System ============== */}
        <Route
          path="/system/*"
          element={
            <Protect allowTypes={['system']}>
              <Layout>
                <Routes>
                  <Route path="settings" element={<SstemSettings />} />
                  <Route path="*" element={<Navigate to="settings" replace />} />
                </Routes>
              </Layout>
            </Protect>
          }
        />

        {/* ルート誘導 */}
        <Route
          path="/"
          element={
            isAdmin() ? <Navigate to="/enduser/usersettings" replace /> :
            isOperator() ? <Navigate to="/enduser/usersettings" replace /> :
            isEnduser() ? <Navigate to="/enduser/usersettings" replace /> :
            isSystem() ? <Navigate to="/enduser/usersettings" replace /> :
            <Navigate to="/login" replace />
          }
        />

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Notification />
    </div>
  );
};

export default App;